/*
* @desc 登录
* @author caoyx
*/
import styles from './login.scss';
import { Checkbox, Form, Icon, Input } from 'antd';
import React, { PureComponent } from 'react';
// import { Link } from 'react-router';
import { hashHistory } from 'react-router';
import { CURRENT_USER_INFO } from '../../constants/common';
import { getCookie, setCookie } from '../../utils/cookie';
import { isNotEmpty } from '../../utils/util';
import { setLocal } from '../../utils/storage';
import { login } from '../../services/login';

const FormItem = Form.Item;
/**
 * @desc 登录页
 * @author caoyx
 */
class Login extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            passwordType: 'text',
            username: '',
            password: '',
            remember: false
        };
    }

    componentDidMount() {
        // 回填登录信息
        const loginInfo = getCookie('crsc1LoginInfo');
        if (loginInfo && isNotEmpty(loginInfo)) {
            const { username, password, remember } = JSON.parse(loginInfo);
            this.setState({
                passwordType: 'password',
                username,
                password,
                remember
            });
        }
    }

    changeInputType = e => {
        this.setState({
            passwordType: 'password'
        });
    };

    // 登录
    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                const { username, password, remember } = values;
                // 是否记住用户名和密码，存储在cookie（7天）
                if (remember) {
                    if (this.state.remember) {
                        setCookie('crsc1LoginInfo', JSON.stringify({ username, password, remember }));
                    }
                } else {
                    setCookie('crsc1LoginInfo', '');
                }

                login({
                    username,
                    password,
                    remember: remember ? 1 : 0
                }).then(data => {
                    setLocal(CURRENT_USER_INFO, data);
                    hashHistory.replace('/');
                });
            }
        });
    };

    render() {
        const { passwordType, username, password, remember } = this.state;
        const { getFieldDecorator } = this.props.form;

        return (
            <div className="not-login-bg">
                <div className="form-box">
                    <Form onSubmit={this.handleSubmit}>
                        <FormItem>
                            {getFieldDecorator('username', {
                                // rules: [{ required: true, message: '请输入邮箱/手机号码！' }, EmallOrCellphoneCheck],
                                rules: [{ required: true, message: '请输入用户名！' }],
                                initialValue: username
                            })(
                                <Input
                                    addonBefore={<Icon type="user" />}
                                    placeholder="请输入用户名"
                                    size="large"
                                    autoComplete="off"
                                />
                            )}
                        </FormItem>
                        <FormItem>
                            {getFieldDecorator('password', {
                                rules: [{ required: true, message: '请输入密码！', whitespace: true }],
                                initialValue: password
                            })(
                                <Input
                                    addonBefore={<Icon type="lock" />}
                                    type={passwordType}
                                    placeholder="请输入密码"
                                    size="large"
                                    autoComplete="new-password"
                                    onFocus={this.changeInputType}
                                />
                            )}
                        </FormItem>
                        <FormItem className={styles.rememberItem}>
                            {getFieldDecorator('remember', {
                                valuePropName: 'checked',
                                initialValue: remember
                            })(<Checkbox>记住用户名和密码</Checkbox>)}
                            {/* <Link to="/wjmm" className={styles.passwordForgot}>
                                忘记密码
                            </Link> */}
                        </FormItem>
                        <FormItem>
                            <button type="submit" className="btn btn-primary">
                                立即登录
                            </button>
                        </FormItem>
                    </Form>
                </div>
            </div>
        );
    }
}

export default Form.create()(Login);



// WEBPACK FOOTER //
// ./src/components/login/Login.jsx